/* eslint-disable no-param-reassign */
/* eslint-disable no-cond-assign */
/* eslint-disable no-restricted-syntax */
import moment from "moment";
import DATE_FORMATS from "./constants";

export const presanitise = time => {
  // take out any whitespace
  time = time.replace(/\s/, "");

  // special case for times < 0959
  if (time.match(/^[0-9]{3}$/)) {
    time = `0${time.substr(0, 1)}:${time.substr(1, 2)}`;
  }

  return time;
};

/*
 * Was this a special case for times < 0959 as per #presanitise()?
 */
export const wasBeforeTen = time => time.replace(/\s/, "").match(/^[0-9]{3}$/);

export const getUsedFormat = (time, throwError = true) => {
  let format;
  time = presanitise(time);

  // try lots of different time formats
  const timeFormats = [];
  for (const separator of [":", ";", "\\h", ",", ".", ""]) {
    for (format of [
      "HH:mm",
      "H:m",
      "hh:mma",
      "hh:mmA",
      "h:ma",
      "h:mA",
      "h:mm"
    ]) {
      timeFormats.push(format.replace(":", separator));
    }
  }
  for (format of ["hha", "hhA", "ha", "hA", "HH", "hh", "h"]) {
    timeFormats.push(format);
  }

  for (format of timeFormats) {
    const test = moment(time, format, true); // true to enable strict format parsing (otherwise it will interpret 5pm as 5:00)
    if (test.isValid()) {
      return format;
    }
  }

  if (throwError) {
    throw new Error(`Could not parse time '${time}'`);
  }
  return false;
};

/*
 * Time format strings that could mean two things, e.g. '5.00' could be 5am or 5pm
 * Used to satisfy Issue #158
 */
export const vagueFormats = () => {
  // try lots of different time formats
  const timeFormats = [];
  for (const separator of [":", ";", ",", ".", ""]) {
    // 'h' is a specific format
    for (const format of ["H:m", "h:mm", "hh", "h"]) {
      timeFormats.push(format.replace(":", separator));
    }
  }

  return timeFormats;
};

/**
 * Convert a user input sring such as "5pm" into a valid time for the API '17:00
 *
 * @param defaultValue if set, return this if no valid time could be foundl otherwise an {@link Error} will be thrown
 * @param now the current time, or {@code false} if we should use right now. ignore the date part of the time
 */
export const convert = (originalTime, now, defaultValue) => {
  const time = presanitise(originalTime);
  if (now) {
    now = moment(now);
  } else {
    now = moment();
  }

  const format = getUsedFormat(time, !defaultValue);
  if (!format) {
    if (defaultValue) {
      return defaultValue;
    }
    throw new Error(`Could not parse time '${time}'`);
  }

  let result = moment(time, format);

  // issue #158: should we be adding 12 hours for early times?
  // also, only for dates that are today
  const nowDate = now.format(DATE_FORMATS.Date);
  const todaysDate = moment().format(DATE_FORMATS.Date);
  if (nowDate === todaysDate) {
    if (result.hour() < 12) {
      const resultPlusAnHour = moment(result).add("h", 1); // .add() mutates the current object :(

      if (
        now.format(DATE_FORMATS.Time) >=
        resultPlusAnHour.format(DATE_FORMATS.Time)
      ) {
        let needle;
        if (
          ((needle = format), vagueFormats().includes(needle)) ||
          wasBeforeTen(originalTime)
        ) {
          result = result.add("h", 12);
        }
      }
    }
  }

  return result.format(DATE_FORMATS.Time);
};
